import React, { ReactElement } from 'react';
import { PageWrapper } from '../../components/page/PageWrapper';
import { useOperatorData } from '../../api/operator/useOperatorData';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box } from '@material-ui/core';

const columns: GridColDef[] = [
  {
    field: 'tenantName',
    headerName: 'Name',
    width: 250,
  },
  {
    field: 'tenantCreationDate',
    headerName: 'Erstellt am',
    width: 150,
    type: 'date',
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'totalChallenges',
    headerName: 'Forderungen',
    width: 150,
    type: 'number',
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'challengesInLastThirtyDays',
    headerName: 'Forderungen (30 Tage)',
    width: 150,
    type: 'number',
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'latestChallenge',
    headerName: 'Letzte Forderung',
    width: 250,
    type: 'date',
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'totalResults',
    headerName: 'Ergebnisse',
    width: 150,
    type: 'number',
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'resultsInLastThirtyDays',
    headerName: 'Ergebnisse (30 Tage)',
    width: 150,
    type: 'number',
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'latestResult',
    headerName: 'Letztes Ergebnis',
    width: 250,
    type: 'date',
    align: 'right',
    headerAlign: 'right',
  },
];

export const OperatorPage = (): ReactElement | null => {
  const { data } = useOperatorData();
  if (!data) {
    return null;
  }
  return (
    <PageWrapper title={'Operator'}>
      <Box height={'calc(100vh - 10vh)'} width={'100%'}>
        <DataGrid rows={data} columns={columns} />
      </Box>
    </PageWrapper>
  );
};
